import React from "react";

export const SiteNotFound: React.FC<{ errors: string[] }> = ({ errors }) => (
  <>
    <h1>Error</h1>
    { errors.map((error, i) => (<p key={i}>{ error }</p>)) }
  </>
);
